import makeStyles from '@mui/styles/makeStyles';

import { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import {Grid} from "@mui/material"
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//assets
import tempoControlBack from "assets/phase2/8.png";


const useStyles = makeStyles((theme) => ({
  
}));

/**
 * @component UpDownButton
 */

const UpDownButton = forwardRef(
  ({ value, onValueChange, layerName, min , max , locked, textSize }, ref) => {
    const classes = useStyles();

    const [componentValue, setComponentValue] = useState(value);

    useImperativeHandle(ref, () => ({
        reset(){
            setComponentValue(0);
        }
    }));

    useEffect(()=>{
        onValueChange(componentValue)
    },[componentValue])

    return (
        <Grid
        container
        direction="column"
        style={{
          textAlign: "center",
          alignItems: "center",
          height: "100%",
          width:"100%",
          backgroundImage: `url(${tempoControlBack})`,
          backgroundSize: "100% auto",
          backgroundRepeat: "no-repeat",
          backgroundPosition:"center"
        }}
      >
        <Grid
          item
          style={{ width: "100%", height: "25%" }}
          onClick={() => {
            // handelTransposeChange(1);
            if(componentValue>=max || locked) return;
            setComponentValue(componentValue=> componentValue+1)
          }}
        ></Grid>

        <Grid item style={{ width: "100%", height: "30%" }}>
          <p
            style={{
              fontSize: textSize || "0.5rem",
              color: "white",
              position: "relative",
              top:"10%"
            }}
          >
            {componentValue}
          </p>
        </Grid>

        <Grid
          item
          style={{ width: "100%", height: "25%" }}
          onClick={() => {
            if(componentValue<=min || locked) return;
            setComponentValue(componentValue=> componentValue-1)
          }}
        ></Grid>
      </Grid>
    );
  }
);

export default UpDownButton;
